import { ACCOUNT_DATA_SHOW } from '@op/pages/CustomizedReports/WeeklyReport/constants';
import { DownloadConfigInfoType } from '../types';
import { channelRenderHelper, ratioReduce } from '../renderHelper';
import { getWeeklyAccountTable } from '@op/services';
import { DBO_REQ } from '@op/utils/format';

export const OfficialAccountsPerformanceTableDownload: DownloadConfigInfoType =
  {
    type: 'page',
    columns: () => {
      const tableColumns: any = [
        {
          key: 'channel',
          header: 'Channel',
          renderHelper: [channelRenderHelper],
        },
        {
          key: 'account_name',
          header: 'Account',
        },
      ];

      ACCOUNT_DATA_SHOW.forEach(
        ({ key, text, header, format, width, ...config }) => {
          const realText = header || text;
          tableColumns.push(
            {
              key,
              header: realText,
              ...config,
            },
            {
              key: `${key}_qoq`,
              header: `${realText} Change%`,
              renderHelper: [ratioReduce()],
              numFmt: ['0.00%'],
            },
          );
        },
      );

      return tableColumns;
    },
    downloadFunc: filter => {
      return getWeeklyAccountTable({ data: filter }).then(data => {
        const { list, total } = data;
        const tableRecord = DBO_REQ.table(list, {
          newListKey: 'new_stats',
          oldListKey: 'old_stats',
          hasQOQ: true,
          hasRATIO: false,
        });
        return { list: tableRecord, total };
      });
    },
  };
